$.fn.wrapInTag = function (opts) {
  function getText(obj) {
    return obj.textContent ? obj.textContent : obj.innerText;
  }

  function isPhoneNumber(str) {
    // Convert to string if it's a number
    str = String(str);

    var digitsOnly = str.replace(/\D/g, '');
    // Check if it has at least 3 digits and only contains digits/phone characters
    return digitsOnly.length >= 3 && /^[\d\s\-\(\)\+\.]*$/.test(str);
  }

  function highlightPhone(text, searchDigits) {
    // Find all sequences that look like phone numbers (digits with separators)
    // Match sequences of digits and separators that are at least as long as search term
    var phonePattern = /[\d\s\-\.\(\)\+]{7,}/g;
    var tag = opts.tag || "strong";

    return text.replace(phonePattern, function(phoneCandidate) {
      // Extract just digits from this candidate
      var candidateDigits = phoneCandidate.replace(/\D/g, '');

      // Check if the candidate contains our search digits
      if (candidateDigits.indexOf(searchDigits) !== -1) {
        // Find the position where our search digits start
        var startPos = candidateDigits.indexOf(searchDigits);

        // Build a regex to match those specific digits with their formatting
        var pattern = '';
        var digitCount = 0;
        var highlightStart = -1;
        var highlightEnd = -1;

        // Walk through the formatted phone to find where to start/end highlighting
        for (var i = 0; i < phoneCandidate.length; i++) {
          if (/\d/.test(phoneCandidate[i])) {
            if (digitCount === startPos) {
              highlightStart = i;
            }
            if (digitCount === startPos + searchDigits.length) {
              highlightEnd = i;
              break;
            }
            digitCount++;
          }
        }

        if (highlightEnd === -1) highlightEnd = phoneCandidate.length;

        // Highlight the matching portion
        var before = phoneCandidate.substring(0, highlightStart);
        var match = phoneCandidate.substring(highlightStart, highlightEnd);
        var after = phoneCandidate.substring(highlightEnd);

        return before + "<" + tag + ">" + match + "</" + tag + ">" + after;
      }

      return phoneCandidate;
    });
  }

  var tag = opts.tag || "strong",
    words = opts.words || [],
    regex,
    replacement = "<" + tag + ">$&</" + tag + ">";

  // Check if this is a phone search
  var isPhone = words.length === 1 && isPhoneNumber(words[0]);
  var searchDigits = isPhone ? String(words[0]).replace(/\D/g, '') : null;

  $(this)
    .contents()
    .each(function () {
      if (this.nodeType === 3) {
        var text = getText(this);
        var newText;

        if (isPhone) {
          newText = highlightPhone(text, searchDigits);
        } else {
          regex = RegExp(words.join("|"), "gi");
          newText = text.replace(regex, replacement);
        }

        $(this).replaceWith(newText);
      } else if (!opts.ignoreChildNodes) {
        $(this).wrapInTag(opts);
      }
    });
};

onmount("[data-js-highlight-text]", function () {
  var highlight_phrase = $(this).data("js-highlight-text");
  if (!!!highlight_phrase) return;

  var color = $(this).data("js-highlight-text-color") || "#009fff";

  $(this).wrapInTag({
    words: [highlight_phrase],
    tag: 'span style="color: ' + color + ';"',
  });
});

window.highlightSearchText = function(){
  $('[data-js-highlight-text]').each(function() {
    var highlight_phrase = $(this).data("js-highlight-text");
    if (!!!highlight_phrase) return;

    var color = $(this).data("js-highlight-text-color") || "#009fff";

    $(this).wrapInTag({
      words: [highlight_phrase],
      tag: 'span style="color: ' + color + ';"',
    });
  });
}
